import React, { PropTypes } from 'react';
import { Modal, Button, Upload, message, Icon, Slider } from 'antd';
import DataService from '../../lib/DataService';
import StringHelper from '../../lib/StringHelper';
import SharedTools from '../../lib/SharedTools';
import ReactQiniuModule from '../../../../lib/ReactQiniuModule';
import UserRoleStore from '../../stores/UserRoleStore';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import UserRoleActions from '../../actions/UserRoleActions';
import CurrentRoleActions from '../../actions/CurrentRoleActions';

export default class EditTeacherModal extends React.Component {
  constructor(props) {
    super(props);
    // set state
    this.state = {
      isEdit: props.isEdit,
      buttonText: props.isEdit ? '确认修改' : '确认添加',
      teacher: props.isEdit ? SharedTools.cloneObject(props.teacher) : {
        avatar_url: '',
        full_name: '',
        mobile_phone: '',
        school_teaching_classes: [],
        avatarWidth: '',
        naturalHeight: '',
        naturalWidth: '',
      },
      loading: false,
      visible: props.visible,
      showClass: false,
      role: CurrentRoleStore.getCurrentRole(),
      classes: [],
      schoolId: props.schoolId,
      other_teaching_classes: [],
      changeState: false,

      // upload avatar_url
      editAvatar: false,
      uploading: false,
      getImgState: false,

      checkedManageClass: [],
      grade:[],
      newTeacherId: 0,
      setAdminFlag: false,
    };
    // bind this
    this.handleCancel = this.handleCancel.bind(this)
    this.handleOk = this.handleOk.bind(this)
    this.selectClass = this.selectClass.bind(this)
    this.changeUserRoleStore = this.changeUserRoleStore.bind(this)
    this.changeCurrentRoleStore = this.changeCurrentRoleStore.bind(this)

    // upload avatar_url
    this.editAvatar = this.editAvatar.bind(this);
    this.onFileUploadSuccess = this.onFileUploadSuccess.bind(this);
    this.isAllUploadingFileFinished = this.isAllUploadingFileFinished.bind(this);
    this.onFileStartUpload = this.onFileStartUpload.bind(this);
    this.changeAvatarSize = this.changeAvatarSize.bind(this);

    this.onManageClassClick = this.onManageClassClick.bind(this);

  }

  componentDidMount() {
    UserRoleStore.addChangeListener(this.changeUserRoleStore);
    CurrentRoleStore.addChangeListener(this.changeCurrentRoleStore);

    DataService.getAllClassRecord(this.state.schoolId).then(res => {
      let classes = [];
      res.forEach((record) =>{
        record.selected = false;
        if (classes.length == 0) {
          classes.push({class_grade_id: record.class_grade_id, class_records: [record]})
        } else {
          let hasState = false;
          classes.forEach((item) => {
            if (record.class_grade_id == item.class_grade_id) {
              item.class_records.push(record);
              hasState = true;
            }
          })
          if (!hasState) {
            let length = classes.length;
            classes.push({ class_grade_id: record.class_grade_id, class_records: [record], is_graduated: record.is_graduated })
          }
        }
      })
      this.setState({
        classes: classes.filter((record) => !record.is_graduated)
      })
    })

    DataService.getAllClassGrade(this.state.schoolId).then((res) => {
      let flag = [];

      flag[0] = {
        id: -1,
        school_id: this.state.schoolId,
        grade_name: '全校',
        resource_type: 'School',
      }
      res.forEach((e,index) => {
        if (!e.is_graduated) {
          e.resource_type = 'grade';
          flag.push(e);
        }
      })

      this.setState({
        grade:flag
      })
    })
  }

  changeCurrentRoleStore() {
    this.setState({
      role: CurrentRoleStore.getCurrentRole()
    })
  }

  changeUserRoleStore() {
    this.setState({
      roles: UserRoleStore.getState()
    })
  }

  componentWillReceiveProps(newProps) {
    let teacher = SharedTools.cloneObject(newProps.teacher);
    this.state.classes.forEach((res) => {
      res.class_records.forEach((record) => {
        record.selected = false;
        if (teacher.school_teaching_classes) {
          teacher.school_teaching_classes.forEach((data) => {
            if (record.id == data.id) {
              record.selected = true;
            }
          })
        }
      })
    })
    if (teacher.avatar_url && (!teacher.avatar_url.match('imageMogr2') && !teacher.avatar_url.match('imageView2'))) {
        teacher.avatar_url = teacher.avatar_url + '?imageView2/1/w/150';
    }
    this.setState({
      isEdit: newProps.isEdit,
      buttonText: newProps.isEdit ? '确认修改' : '确认添加',
      teacher: newProps.isEdit ? teacher : {
        avatar_url: '',
        full_name: '',
        mobile_phone: '',
        school_teaching_classes: [],
        avatarWidth: '',
        naturalHeight: '',
        naturalWidth: '',
      },
      loading: false,
      visible: newProps.visible,
      showClass: false,
      other_teaching_classes: teacher.other_teaching_classes ? teacher.other_teaching_classes : [],
      changeState: false,
      editAvatar: false,
      getImgState: false
    })
  }

  handleOk() {
    this.setState({
      loading: true
    })

    let error = '';
    if (!this.state.teacher.full_name) {
      error = '姓名不能为空';
    } else if (!error && !/^1[3456789]{1}\d{9}$/.test(this.state.teacher.mobile_phone)) {
      error = '请输入正确的手机号';
    }
    if (!error) {
      let data = {};
      data = {
        id: this.state.teacher.id,
        full_name: this.state.teacher.full_name,
        mobile_phone: this.state.teacher.mobile_phone,
        school_id: this.state.schoolId,
      }
      if (this.state.teacher.avatar_url) {
        data.avatar_url = this.state.teacher.avatar_url;
      }
      let school_teaching_classes = this.state.teacher.school_teaching_classes.concat(this.state.other_teaching_classes);
      let class_ids = [];
      school_teaching_classes.forEach((record) => {
        class_ids.push(record.id)
      })
      data.class_ids = JSON.stringify(class_ids);
      DataService.postTeacher(data).then(res => {
        if (this.state.isEdit) {
          message.success('修改成功！');

          // 编辑管理员本人信息
          if (this.state.role.roleId == this.state.teacher.id && this.state.role.roleName == 'teacher') {
            let roles = UserRoleStore.getState();

            // 新增班级role
            school_teaching_classes.forEach((record) => {
              let index = roles.findIndex((role) => (role.associatName == 'classRecord' && role.associatObj.id == record.id));
              if (index < 0) {
                let gradeAdmin = roles.find((role) => (role.associatName == 'classGrade' && role.associatObj.id == record.class_grade_id));
                let schoolAdmin = roles.find((role) => (role.associatName == 'school' && role.associatObj.id == record.school_id));
                let add_role = {
                  id: this.state.role.id,
                  roleId: this.state.role.roleId,
                  roleName: 'teacher',
                  fullName: this.state.role.fullName,
                  associatName: "classRecord",
                  associatObj: {
                    id: record.id,
                    className:record.name,
                    gradeId: record.class_grade_id,
                    gradename: record.grade_name,
                    schoolId: record.school_id,
                    schoolName: record.school_name,
                    isClassAdmin: false,
                    isGradeAdmin: gradeAdmin ? true : false,
                    isSchoolAdmin: schoolAdmin ? true : false,
                  }
                }
                UserRoleActions.addUserRole(add_role)
              }
            })

            // 删除班级role
            roles.forEach((role) => {
              if (role.associatName == 'classRecord' && role.associatObj.schoolId == this.state.schoolId) {
                let index = school_teaching_classes.findIndex((record) => role.associatObj.id == record.id);
                if (index < 0) {
                  UserRoleActions.deleteUserRole(role.key)
                }
              }
            })

            // 更新所有role名字
            if (this.state.role.fullName != this.state.teacher.full_name) {
              let roles = UserRoleStore.getState();
              roles.forEach((role) => {
                if (role.roleName == 'teacher') {
                  UserRoleActions.updateUserRole(role.key, {fullName: this.state.teacher.full_name})
                }
              })
            }
            CurrentRoleActions.refreshCurrentUserRole();
          }
        } else {
        // 在这里调用设置管理员api
          this.setState({
            newTeacherId: res.id,
          })

          let promises = [];
          this.state.checkedManageClass.forEach((index) => {
            promises[index] = this.toBeAdmin(this.state.grade[index]);
          })
          Promise.all(promises).then(() => {
            message.success('添加教师成功');
          }).catch((res) => {
            console.log(res);
            message.info('添加失败，请重试');
          })

          this.state.checkedManageClass = [];
          this.setState({
            checkedManageClass: this.state.checkedManageClass
          })
        }
        this.props.callbackEditTeacher();
        this.setState({
          loading: false,
          visible: false,
        })

      }, (response) => {
        if (response.errorMessage) {
          message.info('添加失败，请重试');
          this.setState({
            loading: false,
          })
        }
      }).catch((error) => {
        console.log(error)
        message.info('添加失败，请重试');
        this.setState({
          loading: false,
        })
      });
    } else {
      message.info(error);
      this.setState({
        loading: false
      })
    }

    // to do: api请求后callback
  }

  handleCancel() {
    this.setState({
      visible: false
    })
    this.props.callbackEditTeacher();
  }

  changeInput(filter, e) {
    this.state.teacher[filter] = e.target.value;
    this.setState({
      teacher: this.state.teacher,
      changeState: true
    })
  }

  selectClass() {
    this.setState({
      showClass: !this.state.showClass,
    })
  }

  selectClassRecord(index, id) {
    let record = this.state.classes[index].class_records.find((record) => record.id == id);
    record.selected = !record.selected;
    this.state.classes.forEach((grade) => {
      grade.class_records.forEach((record) => {
        let state = false;
        this.state.teacher.school_teaching_classes.forEach((res) => {
          if (res.id == record.id && !record.selected) {
            let index = this.state.teacher.school_teaching_classes.findIndex((c) => c.id == record.id);
            this.state.teacher.school_teaching_classes.splice(index, 1);
          } else if (res.id == record.id && record.selected) {
            state = true
          }
        })
        if (!state && record.selected) {
          this.state.teacher.school_teaching_classes.push(record);
        }
      })
    })
    this.setState({
      classes: this.state.classes,
      teacher: this.state.teacher,
      changeState: true
    })
  }

  toBeAdmin(grade){
      let data = {
        resource_type: grade.resource_type === 'School' ? 'school' : 'class_grade',
        resource_id: grade.resource_type === 'School' ? grade.school_id : grade.id,
        teacher_id: this.state.newTeacherId
      }
      DataService.setAdmin(data).then((res) => {
        this.setState({
          setAdminFlag: true
        })
      })
  }

  editAvatar() {
    this.setState({
      editAvatar: true,
    })
  }

  changeAvatarSize(value) {
    let teacher = SharedTools.cloneObject(this.state.teacher);
    let that = this;
    if (!this.state.getImgState) {
      if (!teacher.avatar_url.match('imageMogr2')) {
        teacher.avatar_url = teacher.avatar_url.replace(/\?imageView2(.+)$/, '');
      } else {
        teacher.avatar_url = teacher.avatar_url.replace(/\?imageMogr2(.+)$/, '');
      }
      $.ajax({
        url: `${teacher.avatar_url}?imageInfo`,
        type:'GET',
        dataType:'json',
        success: function(data){
          let width = data.width < data.height ? data.width : data.height
          teacher.avatarWidth = width;
          teacher.naturalWidth = data.width;
          teacher.naturalHeight = data.height;
          width = parseInt(width / value);
          teacher.avatar_url = `${teacher.avatar_url}?imageMogr2/crop/!${width}x${width}a${parseInt((data.width - width) / 2)}a${parseInt((data.height - width) / 2)}`;

          that.setState({
            teacher: teacher,
            getImgState: true,
            changeState: true
          });
        },
        error: function(data){
        }
      })
    } else {
      teacher.avatar_url = teacher.avatar_url.replace(/\?imageMogr2(.+)$/, '');
      let width = parseInt(teacher.avatarWidth / value)
      teacher.avatar_url = `${teacher.avatar_url}?imageMogr2/crop/!${width}x${width}a${parseInt((teacher.naturalWidth - width) / 2)}a${parseInt((teacher.naturalHeight - width) / 2)}`;

      that.setState({
        teacher: teacher,
        changeState: true
      });
    }
  }

  onFileUploadSuccess(newFileKey, fileName, size, remoteUrl) {
    let that = this;
    $.ajax({
      url: `${remoteUrl}?imageInfo`,
      type:'GET',
      dataType:'json',
      success: function(data){
        let width = data.width < data.height ? data.width : data.height
        that.state.teacher.avatarWidth = width;
        that.state.teacher.naturalWidth = data.width;
        that.state.teacher.naturalHeight = data.height;
        that.state.teacher.avatar_url = `${remoteUrl}?imageMogr2/crop/!${width}x${width}a${parseInt((data.width - width) / 2)}a${parseInt((data.height - width) / 2)}`;

        that.setState({
          uploading: false,
          teacher: that.state.teacher,
          editAvatar: true,
          changeState: true,
          getImgState: true
        });
      },
      error: function(data){
      }
    });
  }

  isAllUploadingFileFinished() {
    return !this.state.uploading;
  }

  onFileStartUpload(newFileKey) {
    this.setState({
      uploading: true
    })
    return true;
  }


  // 点击管理年级按钮
  onManageClassClick(index){
    if(this.state.checkedManageClass.indexOf(index)>=0){
      this.state.checkedManageClass.splice(this.state.checkedManageClass.indexOf(index),1);
    }else{
      this.state.checkedManageClass.push(index);
    }

    let flag = this.state.checkedManageClass;

    this.setState({
      checkedManageClass:flag,
    });
  }


  _uploadView() {
    let teacher = SharedTools.cloneObject(this.state.teacher), defaultValue = 1;

    if (teacher.avatar_url && teacher.avatar_url.match('imageMogr2') && !teacher.avatarWidth) {
      let naturalUrl = teacher.avatar_url.replace(/\?imageMogr2(.+)$/, '');
      let matchInfo = teacher.avatar_url.match(/([0-9]+)x([0-9]+)a-?([0-9]+)a-?([0-9]+)/);
      teacher.naturalWidth = Number(matchInfo[1]) + Number(matchInfo[3] * 2);
      teacher.naturalHeight = Number(matchInfo[2]) + Number(matchInfo[4] * 2);
      teacher.avatarWidth = Number(matchInfo[1]);
      defaultValue = ((Math.min(teacher.naturalWidth, teacher.naturalHeight)) / matchInfo[1]).toFixed(1);
    }

    return (
      <div className="edit-student">
        <div className="edit-avatar">
          <div className="avatar-box">
            {this.state.teacher.avatar_url && <img className="avatar" src={this.state.teacher.avatar_url}/>}
            {!this.state.teacher.avatar_url && <div className="avatar no-avatar"></div>}
            {(!this.state.editAvatar && this.state.teacher.avatar_url) && <div className="edit-btn" onClick={this.editAvatar}>编辑头像</div>}
            {(!this.state.editAvatar && !this.state.teacher.avatar_url) &&
              <ReactQiniuModule
                className="edit-btn add-btn"
                onSuccess={this.onFileUploadSuccess}
                onStartPermit={this.onFileStartUpload}
                isAllFinish={this.isAllUploadingFileFinished}
                getUploadQuota={() => {return !this.state.uploading}}
                allowUploadFileTypes={ReactQiniuModule.getFileCategories.ALL}
                allowUploadFileSize={10} >
                <div>+添加照片</div>
              </ReactQiniuModule>
            }
          </div>
          {this.state.editAvatar &&
            <div className="edit-avatar-size">
              <div className="slider-box">
              -
              <Slider min={1} max={3} step={0.1} defaultValue={Number(defaultValue)} onChange={this.changeAvatarSize}/>
              +
            </div>
          </div>}
          {this.state.editAvatar &&
            <ReactQiniuModule
              className="choose-photo"
              onSuccess={this.onFileUploadSuccess}
              onStartPermit={this.onFileStartUpload}
              isAllFinish={this.isAllUploadingFileFinished}
              getUploadQuota={() => {return !this.state.uploading}}
              allowUploadFileTypes={ReactQiniuModule.getFileCategories.ALL}
              allowUploadFileSize={10} >
              <div>重选照片</div>
            </ReactQiniuModule>}
        </div>
      </div>
    )
  }

  _editTeacherView() {
    let school_teaching_classes = this.state.teacher.school_teaching_classes.map((record) => record.name).join(',')
    school_teaching_classes = StringHelper.lengthLimit(school_teaching_classes,28);
    return (
      <div className="modal-teacher-info">
        <div className="modal-input-wrapper">
          <span className="modal-label"><span className="red-point">*</span>
          姓名</span>
          <input className="modal-input" type="text" onChange={this.changeInput.bind(this, 'full_name')} value={this.state.teacher.full_name}/>
        </div>

        <div className="modal-input-wrapper">
          <span className="modal-label"><span className="red-point">*</span>
          手机号</span>
          <input className="modal-input" type="number" onChange={this.changeInput.bind(this, 'mobile_phone')} value={this.state.teacher.mobile_phone}/>
        </div>

        <div className="modal-input-wrapper big-cell" onClick={this.selectClass}>
          <span className="modal-label">
          任教班级</span>
          <input className="modal-input select-class-input" disabled value={school_teaching_classes}/>
          <Icon type="caret-down" className="caret-down"/>
        </div>

          <div className={"class-list-box" + (this.state.showClass ? '' : ' hidden')}>
            {this.state.classes.map((grade, index) => <div className="class-grade" key={index}>
              {grade.class_records.map((record) => <span className={'class-record' + (record.selected ? ' selected' : '')} key={record.id} onClick={this.selectClassRecord.bind(this, index, record.id)}>{record.name}</span>)}
            </div>)}
          </div>

          {!this.state.isEdit &&
          <div className="choose-manage-class" >
          <div className="lablel">设置管理员：</div>
            {this.state.grade.map(
              (grade, index) => 
                <span className={'clazz ' + (this.state.checkedManageClass.indexOf(index) >= 0 ? 'checked' : '')}  key={grade.id} onClick={this.onManageClassClick.bind(this,index)}>{grade.grade_name}管理员</span>
                )}
          </div>
          }
      </div>
    )
  }

  render() {
    return (
      <Modal className="school-admin-add-teacher-modal"
        visible={this.state.visible}
        title={null}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        maskClosable={false}
        footer={[
          <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.handleOk} className="footer-btn" disabled={!this.state.changeState}>
            {this.state.buttonText}
          </Button>,
        ]}>
        {this._uploadView()}
        {this._editTeacherView()}
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/schooladmin/EditTeacherModal.jsx